import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Briefcase } from 'lucide-react'
import { UseFormReturn } from 'react-hook-form'

export const EmploymentTypeInput = ({form,disabled}:{form:UseFormReturn<any>,disabled?:boolean}) => {
    return (
        <FormField
            control={form.control}
            name="employmentType"
            render={() => (
                <FormItem className="space-y-2">
                    <Label htmlFor="employmentType" className="text-base font-semibold flex items-center gap-2">
                        <Briefcase className="w-5 h-5" />
                        Employment Type
                    </Label>
                    <FormControl>
                        <Input
                            id="employmentType"
                            placeholder="Enter Employment Type"
                            {...form.register("employmentType")}
                            //required
                            className={`w-full transition-all duration-200 focus:ring-2 focus:ring-[#22b4b1] ${
                                form.formState.errors["employmentType"] ? "border-red-500" : "border"
                            }`}
                            disabled={disabled}
                            />
                    </FormControl>
                    {form.formState.errors["employmentType"] && (
                        <FormMessage className="text-red-500"/>
                    )}
                </FormItem>
            )}
        />
  )
}
